// src/components/JourneyStrip.tsx
import React from 'react';

interface JourneyStripProps {
  currentStatus: string;
  createdBy: string;
  assigneeName?: string;
}

const statusFlow = {
  'TODO': { order: 1, label: 'To Do', icon: '📋' },
  'IN_PROGRESS': { order: 2, label: 'In Progress', icon: '⚙️' },
  'IN_REVIEW': { order: 3, label: 'Review', icon: '🔍' },
  'BLOCKED': { order: 4, label: 'Blocked', icon: '🚫' },
  'DONE': { order: 5, label: 'Done', icon: '✅' },
  'CANCELLED': { order: 6, label: 'Cancelled', icon: '❌' },
};

export function JourneyStrip({ currentStatus, createdBy, assigneeName }: JourneyStripProps) {
  const steps = [
    { label: 'Created', user: createdBy, status: 'done', icon: '✓' },
    { label: 'Assigned', user: assigneeName, status: assigneeName ? 'done' : 'pending', icon: '○' },
    { label: 'In Progress', status: currentStatus === 'IN_PROGRESS' ? 'active' : currentStatus === 'DONE' ? 'done' : 'pending', icon: '⚙️' },
    { label: 'Review', status: currentStatus === 'IN_REVIEW' ? 'active' : currentStatus === 'DONE' ? 'done' : 'pending', icon: '🔍' },
    { label: 'Complete', status: currentStatus === 'DONE' ? 'done' : currentStatus === 'CANCELLED' ? 'cancelled' : 'pending', icon: '✓' },
  ];

  const getStepStyle = (status: string) => {
    switch (status) {
      case 'done':
        return { bg: '#ECFDF5', border: '#059669', text: '#059669' };
      case 'active':
        return { bg: '#EFF6FF', border: '#2563EB', text: '#2563EB' };
      case 'cancelled':
        return { bg: '#FEF2F2', border: '#DC2626', text: '#DC2626' };
      default:
        return { bg: '#F9FAFB', border: '#E2E8F0', text: '#94A3B8' };
    }
  };

  return (
    <div className="flex items-center justify-between w-full py-2">
      {steps.map((step, idx) => {
        const style = getStepStyle(step.status);
        return (
          <React.Fragment key={idx}>
            <div className="flex flex-col items-center flex-1 min-w-0">
              <div
                className="w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold transition-all"
                style={{
                  backgroundColor: style.bg,
                  border: `2px solid ${style.border}`,
                  color: style.text,
                }}
              >
                {step.icon}
              </div>
              <span className="text-xs mt-1 font-medium truncate max-w-[70px]" style={{ color: style.text }}>
                {step.label}
              </span>
              {step.user && (
                <span className="text-xs text-gray-400 truncate max-w-[70px]">
                  {step.user.split(' ')[0]}
                </span>
              )}
            </div>
            {idx < steps.length - 1 && (
              <div
                className={`flex-1 h-0.5 rounded-full mx-1 ${
                  step.status === 'done' ? 'bg-green-500' : 'bg-gray-200'
                }`}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}